import { useState } from 'react'
import { T } from '@/lib/theme'
import { ADDRESSES, IS_LIVE, ZERO_ADDR } from '@/lib/contracts'
import { truncAddr } from '@/lib/utils'
import horizonIcon from '@/assets/tokens/horizon.webp'
import usdxIcon from '@/assets/tokens/usdx.webp'


/// Contract addresses for the two tokens every product on this site revolves around - HORIZON
/// (emissions/staking) and USDx (the pairing/collateral asset) - centered at the bottom of every
/// page, click-to-copy. Nothing renders until Horizon is actually live on the connected network:
/// pre-launch the deployed build still carries dev-chain addresses, and a click-to-copy address
/// that resolves to a non-existent mainnet token is worse than no pill at all. A zero/blank
/// ADDRESSES entry also hides its pill (deployed-but-partial), never a copyable "0x000...000".
export function Footer() {
  const tokens = (IS_LIVE ? [
    { label: 'HORIZON', icon: horizonIcon, address: ADDRESSES.HORIZON_TOKEN },
    { label: 'USDx', icon: usdxIcon, address: ADDRESSES.USDX },
  ] : []).filter((t) => t.address && t.address.toLowerCase() !== ZERO_ADDR)

  if (tokens.length === 0) return null

  return (
    <footer style={{ padding: '40px 16px 48px', textAlign: 'center' }}>
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        gap: 12, flexWrap: 'wrap',
      }}>
        {tokens.map((t) => <TokenAddressPill key={t.label} {...t} />)}
      </div>
    </footer>
  )
}

function TokenAddressPill({ label, icon, address }) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    try {
      await navigator.clipboard.writeText(address)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch (e) {
      console.error('clipboard write failed:', e)
    }
  }

  return (
    <button
      onClick={copy}
      title={address}
      style={{
        display: 'flex', alignItems: 'center', gap: 8,
        padding: '9px 16px', borderRadius: T.r.pill, cursor: 'pointer',
        border: `1px solid ${copied ? T.positive : T.border}`,
        background: 'rgba(255,255,255,0.02)',
        transition: 'border-color 0.15s ease',
      }}
    >
      <img src={icon} alt="" width={18} height={18} style={{ borderRadius: '50%', flexShrink: 0, objectFit: 'cover' }} />
      <span style={{ color: T.text, fontFamily: T.fontM, fontSize: T.fs.caption, fontWeight: 700 }}>{label}</span>
      <span className="mono" style={{ color: T.textDim, fontFamily: T.fontN, fontSize: T.fs.caption }}>
        {truncAddr(address)}
      </span>
      <span style={{ color: copied ? T.positive : T.textDim, fontFamily: T.fontM, fontSize: 11, fontWeight: 700, minWidth: 46, textAlign: 'left' }}>
        {copied ? 'Copied ✓' : 'Copy'}
      </span>
    </button>
  )
}
